import type { ImageProps } from '@chakra-ui/react'
import { Image } from '@chakra-ui/react'
import { OfferType } from 'BrokerTsLib/src/dtos'
import type { IOfferCompany } from 'BrokerTsLib/src/enums'
import { Insurer } from 'BrokerTsLib/src/enums'

import { usePartner } from '../context/PartnerContext'
import { getLogo, SpecialLogoIds } from '../utils/companiesLogos'

export interface CompanyLogoProps extends ImageProps {
  insurer?: IOfferCompany,
  offerType: OfferType
}

export const CompanyLogo = ({ insurer, offerType, width, height, ...rest }: CompanyLogoProps) => {
  let insurerId = insurer?.id
  let insurerName = insurer?.name

  const { currentPartner } = usePartner()

  if (offerType == OfferType.ZnacnovePojisteniSubaru) {
    insurerId = SpecialLogoIds.SubaruPojisteni
    insurerName = 'Subaru pojištění'
  }
  if (insurerId == Insurer.Custom && currentPartner?.partner == 'Respect') {
    insurerId = SpecialLogoIds.RespectAssistance
    insurerName = 'Respect Assistance'
  }

  if (!insurerId)
    return null

  return (
    <Image src={getLogo(insurerId)} alt={insurerName} width={width} maxH={height} minWidth={width} {...rest} />
  )
}